import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Twitter: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-540v-540h465c41.35 0 75 33.64 75 75zm-210-30h180v-435c0-24.81-20.19-45-45-45h-435v480z' />
    <path d='m200.93 212.17 146.71 196.17-147.64 159.49h33.23l129.26-139.64 104.44 139.64h113.08l-154.97-207.2 137.42-148.46h-33.23l-119.04 128.61-96.18-128.61zm48.86 24.48h51.95l229.39 306.71h-51.95l-229.39-306.72z' />
  </IconBase>
));

Twitter.displayName = 'Twitter';

export default Twitter;
